export default {
  props: {
    ctxA: {
      type: Object,
      default: () => {}
    },
    store: {
      type: Object
    },
    theme: String
  },
  data() {
    return {};
  },
  computed: {
    ctx() {
      return { ...this.defaultSchema, ...this.ctxA };
    },
    formValues() {
      return this.store.state.formValues;
    },
    context() {
      return this.store.state.context;
    }
  }
};
